// app/javascript/controllers/dissolve_controller.js
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    if (this.element.id === 'first-block') {
      this.showBlock(this.element);
    }
  }

  showBlock(element) {
    console.log(element);
    element.classList.add('m-text-show');
    setTimeout(() => {
      this.hideBlock(element);
    }, 3000);
  }

  showNextBlock(element) {
    if (element) {
      element.classList.add('m-text-show');
      setTimeout(() => {
        this.showPlanReviewPage();
      }, 3000);
    }
  }

  hideBlock(element) {
    if (element) {
      element.classList.remove('m-text-show');
      const nextBlock = element.nextElementSibling;
      if (nextBlock) {
        this.showNextBlock(nextBlock);
      }
    }
  }

  showPlanReviewPage() {
    const hiddenButton = document.getElementById('m-plan-review-button');
    if (hiddenButton) {
      hiddenButton.click();
    } else {
      console.error('Hidden button not found');
    }
  }
}
